// extracted by css-extract-rspack-plugin
export default {"maxHeight":"AttachmentsTabPanel_maxHeight__7dh-k"};